import { identityRequest } from '../../routes/acquisition/identity';

export const LOGOUT_DESTINATION = '/';

/** Revoke identity sessions, or close the private production site's browser workspace gate. */
export async function endSession(member: boolean, passwordGate = false): Promise<string> {
  if (member || !passwordGate) {
    await identityRequest('logout', {});
    return LOGOUT_DESTINATION;
  }
  const response = await fetch('/auth/logout', {
    method: 'POST',
    credentials: 'same-origin',
    cache: 'no-store',
    headers: { 'X-AdOrchestrator-Logout': '1' },
  });
  if (!response.ok) throw new Error('Workspace logout failed');
  return LOGOUT_DESTINATION;
}
